// Light FontAwesome Icons

// Regular FontAwesome Icons

// Solid FontAwesome Icons
import TagSolidIcon from '@/assets/svgs/solid/tag.svg?component';

export const SVGIcons = {
  // light

  // regular

  // solid
  'fas-tag': TagSolidIcon,
} as const;

export type SVGName = keyof typeof SVGIcons;
